import React, { Suspense, useState, useEffect } from 'react'
// import { CiMenuFries } from "react-icons/ci";
// import { GrClose } from "react-icons/gr";
// import AccordinItem from './components/AccordinItem';
import { faqAnswers, faqQuestions } from './components/AccordinItem/data';
import VantagemItem from "./components/VantagensItem";
import { vantagensData } from "./components/VantagensItem/data";
import uniqFeature from '../../assets/LottieAnimation/uniqFeature.json';
import flexiblePaymentOption from '../../assets/LottieAnimation/flexiblePaymentOption.json';
import addMember from '../../assets/LottieAnimation/addMember.json';
import PricingTable from './components/PricingTable';
// import VideoAnimationCard from './components/VideoAnimationCard';
import SharedImage from './components/SharedImage';
// import IconsSection from './components/IconSection';
import Navbar from '../HomePage/header';
import SignInForm from '../SignIn/SignInForm';
import CreateAccount from '../CreateAccount/CreateAccount';
import "./index.css"
import QuestionAns from '../FAQs/QuestionAns';
import AutoPlaySlider from '../../NewComponents/AutoPlaySlider';
import { iconImages } from './components/IconSection/data';
import { ReactComponent as Company1 } from "../../assets/Company/Company1.svg";
import { ReactComponent as Company2 } from "../../assets/Company/Company2.svg";
import { ReactComponent as Company3 } from "../../assets/Company/Company3.svg";
import { ReactComponent as Company4 } from "../../assets/Company/Company4.svg";
import { ReactComponent as Company5 } from "../../assets/Company/Company5.svg";
import { ReactComponent as TranslationIcon } from "../../assets/Feature/translationsIcon.svg";
import { ReactComponent as CardPayIcon } from "../../assets/Feature/CardPayIcon.svg";
import { ReactComponent as MembersToTeam } from "../../assets/Feature/MembersToTeam.svg";
import { ReactComponent as MarketingBannerLogo } from "../../assets/icons/marketing_banner.svg";

import { ReactComponent as Frame1 } from "../../assets/home/Frame1.svg";
import { ReactComponent as Frame2 } from "../../assets/home/Frame2.svg";
import { ReactComponent as Group2 } from "../../assets/home/Group2.svg";
import { ReactComponent as Listbox } from "../../assets/home/Listbox.svg";
import mexicoFlag from "../../assets/flags/mexicoFlag.png";
import germanyFlag from "../../assets/flags/germanyFlag.png";
import USAFlag from "../../assets/flags/USAFlag.png";
import Slider from 'react-slick';
import Footer from '../HomePage/footer';
import { useScreenTransition } from '../../Hooks/useScreenTransition';
import UniqueFeatures from '../HomePage/UniqueFeatures';

const CustomerReviews = React.lazy(() => import("../HomePage/CustomerReviews"));

const marketingLink = "/?business=A9GzYZMhrehJkBGeQaL7&create-account=true";

const menuItems = [
    {
        title: "Features",
        path: "/partner",
        id: "features",
    },
    {
        title: "Why Us",
        path: "/partner",
        id: "why-us",
    },
    
    {
        title: "Reviews",
        path: "/partner",
        id: "reviews",
    },
    
    {
        title: "Start Now",
        path: "/partner",
        id: "start-now",
    },
   
    {
        title: "FAQs",
        id: "faqs",
        path: "/partner",
      },
    
    
];

const menuItems1 =  [
    {
      title: "Features",
      path: "/partner",
      id: "features",
    },
    {
      title: "Why Us",
      path: "/partner",
      id: "why-us",
    },
    {
      title: "Reviews", 
      path: "/partner",
      id: "reviews",
    },
  ];

  const menuItems2 = [
    {
      title: "Start Now",
      path: "/partner",
      id: "start-now",
    },
    {
      title: "FAQs",
      id: "faqs",
      path: "/partner",
    },
  ];

const MarketingLandingPage = ({ windowSize }) => {
    const { transitionTo } = useScreenTransition();
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCreateAccountOpen, setIsCreateAccountOpen] = useState(false);

    useEffect(() => {
        if (windowSize.width > 950 && isMenuOpen) {
            setIsMenuOpen(false);
        }
    }, [windowSize, isMenuOpen]);

    const animations = [
        {anim: uniqFeature, text1: "Get", text2: "translated", text3: "in 4 hours or less", icon: <TranslationIcon />}, 
        {anim: flexiblePaymentOption, text1: "Flexible", text2: "payment", text3: "options", icon: <CardPayIcon />}, 
        {anim: addMember, text1: "Add", text2: "members", text3: "to your team", icon: <MembersToTeam />}, 
    ];

    const handleLoginOpen = (newState) => {
        setIsModalOpen(newState);
    };

    const handleCreateAccountOpen = (newState) => {
        setIsCreateAccountOpen(newState);
    };


    const [activeIndex, setActiveIndex] = useState(null);

    const handleToggle = (index) => {
      setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    const settings = {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1500,
        autoplaySpeed: 3000,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };

    return (
        <div className='bg-[#EFF3F5] w-full flex flex-col items-center cursor-default'>
            <SignInForm
                open={isModalOpen}
                isLoginFormOpen={handleLoginOpen}
                isCreateAccountOpen={handleCreateAccountOpen}
            />
            <CreateAccount
                open={isCreateAccountOpen}
                isCreateAccountOpen={handleCreateAccountOpen}
                isLoginFormOpen={handleLoginOpen}
            />

           

            {/* banner */}
            <div className='w-full md:p-4 p-2'>

                <div className='w-full bg-[#12ABBF] rounded-4xl max-md:rounded-xl'>
                    {/* navbar */}
                <div className=' pt-[30px] pb-[27px] mx-4'>
                    <Navbar windowSize={windowSize} isLoginFormOpen={handleLoginOpen} menuItems={menuItems} defaultPath="/partner" />
                </div>
                    <div className='bannerContainer px-2'>
                        {/* <SharedImage
                            src={require("../../assets/banner_img.png")}
                            alt="banner image"
                            width={312}
                            height={312}
                            fixed
                            className="object-cover rounded-lg"
                            /> */}

                            <MarketingBannerLogo width={312} height={312} className='min-w-[312px] min-h-[312px]' />

                        <h1 className='bannerText'>Flawless Legal Translations for Law Firms. Fast, Accurate, all in one place and with <span>Unbeatable Pricing</span></h1>
                    </div>


                    <div className=" container  justify-center gap-4 lg:mt-32 mt-10 relative mx-auto flex  w-full">
                        <Frame1 className="max-h-full max-w-full  bg-cover bg-no-repeat lg:block hidden" />

                        <div className="relative sm:block hidden">
                        <Frame2 className="max-h-full max-w-full  bg-cover bg-no-repeat" />
                        <div className="absolute bg-white lg:hidden flex justify-center items-center p-4 rounded-full z-20 -top-6 -left-6 shadow-md">
                            <img src={USAFlag} alt="Flag" className="h-10 w-10" />
                        </div>
                        <div className="absolute bg-white lg:hidden flex justify-center items-center p-3 rounded-full z-20 -bottom-6 -right-6 shadow-md">
                            <img src={mexicoFlag} alt="Flag" className="h-10 w-10" />
                        </div>
                        </div>

                        <div className="relative sm:hidden block">
                        <Listbox className="max-h-full max-w-full  bg-cover bg-no-repeat" />
                        <div className="absolute bg-white lg:hidden flex justify-center items-center p-3 rounded-full z-20 -top-6 -left-8 shadow-md">
                            <img src={USAFlag} alt="Flag" className="h-10 w-10" />
                        </div>
                        </div>

                        <div className="absolute bg-white lg:flex hidden justify-center items-center p-4 rounded-full z-20 -top-6 left-[53%] shadow-md">
                        <img src={USAFlag} alt="Flag" className="h-10 w-10" />
                        </div>

                        <div className="absolute -top-1/2 lg:block hidden">
                        <div className="w-full relative">
                            <div className="absolute bg-white flex justify-center items-center p-3 rounded-full z-50 top-12 left-6 shadow-md">
                            <img src={germanyFlag} alt="Flag" className="h-8 w-8" />
                            </div>
                            <div className="absolute bg-white flex justify-center items-center p-3 rounded-full z-50 bottom-12 right-6 shadow-md">
                            <img src={mexicoFlag} alt="Flag" className="h-8 w-8" />
                            </div>
                            <Group2 className="z-40 max-h-full max-w-full bg-cover bg-no-repeat" />
                        </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* flags and text */}
            <div className='flagSectionContainer'>
                <p className='flagText'> 🇲🇽 🇨🇳 🇻🇳 🇰🇷 🇧🇷 🇷🇺 🇺🇦 🇫🇷 🇮🇳 🇦🇫 🇵🇭 🇮🇷 🇹🇭 🇹🇷 🇯🇵 🇩🇪 🇮🇹 🇵🇹 🇬🇷 🇵🇱 🇦🇷</p>
                <div className='mt-6 w-full'>
                    <h2 className='flagSectionText'>Specialized translation services that meet all legal requirements, with a complimentary QA review included.
                        <br /> <br /> <span>Eliminate competitors' surcharges and the hassle of managing translations via email.</span>
                    </h2>
                </div>
            </div>

            <div className='max-w-[1440px] w-full px-2'>
                <UniqueFeatures customButtonText={"Start now for $24.95/page"} customButtonLink={() => window.open(marketingLink, "_blank")}/>
            </div>
            
            {/* green button */}
            <div className='greenBtn hover:scale-[1.02] transition-all duration-300' onClick={() => transitionTo(marketingLink)}>Start now for $24.95/page</div>

            {/* organize work flow section */}
            <div className='mainContainer'>
                <div className='workFlowSection'>
                    <p><span>Stop</span> losing time and money in the chaos of managing translations</p>
                    <p>
                        Are you still managing urgent translations through endless emails and losing track of your clients' documents? <span>Disorganization costs time and money</span>.
                        <br /><br />
                        With eVerbary, we don't just give you perfect translations; we offer an intuitive platform where you can view and manage all of your firm's orders.
                        <br /><br />
                        <span>Organize your translations by client, track progress in real time, and access finished documents anytime. All without the need for extensive training.</span>
                    </p>
                    {/* green button */}
                    <div className='hover:scale-[1.02] transition-all duration-300' onClick={() => transitionTo(marketingLink)}>Organize your workflow today</div>
                </div>
            </div>

            {/* logo images */}
            {/* <div className='logoImagesSection'>
                <SharedImage
                    src={require("../../assets/logoImages.png")}
                    alt="logo images"
                />
            </div> */}

            <div className='max-w-[1440px] w-full px-4'>
                <div className="w-full bg-white rounded-4xl mt-5 p-4 shadow-md space-y-5">
                    <div className="text-center">
                    <p className=" tex-[#2D3643] text-xl ">
                    Built for immigration experts, inspired by the tools they trust
                    </p>
                    </div>
                    {windowSize.width > 1024 ? (
                    <div className="container mx-auto flex gap-4 mt-4 justify-evenly">
                        <Company1 />
                        <Company2 />
                        <Company3 />
                        <Company4 />
                        <Company5 />
                    </div>
                    ) : (
                    <div className="container mx-auto">
                        <Slider {...settings}>
                        <Company1 />
                        <Company2 />
                        <Company3 />
                        <Company4 />
                        <Company5 />
                        </Slider>
                    </div>
                    )}
                </div>
            </div>
            {/* Logo Letter and text section */}
            <div className='logoLetterAndText' id="why-us">
                <SharedImage
                    src={require("../../assets/eVerbary Logo_Letter E_Original 3.png")}
                    alt="logo letter eVerbary"
                    width={339}
                    height={339}
                    className="object-contain"
                />
                <p>The only platform that combines impeccable legal translations with unprecedented document management and no hidden additional costs.</p>
            </div>

            {/* vantagens section */}
            <div className='vantagensSection'>
                {vantagensData.map((item, index) => (
                    <VantagemItem
                        key={index}
                        icon={item.icon}
                        title={item.title}
                        text={item.text}
                    />
                ))}
            </div>

            {/* blue button */}
            <div className='blueBtn hover:scale-[1.02] transition-all duration-300' onClick={() => transitionTo(marketingLink)}>Boost your team’s efficiency now </div>

            {/* Hand shake Image section */}
            <div className="greenCurveWrapper">

                <img
                    src={require('../../assets/handshake-2.png')}
                    alt=''
                    className='w-full'
                />
                <p className="textUnderImage">
                    More than 1,250 law firms already trust our platform.
                </p>

            </div>

            {/* icons section */}
            {/* <IconsSection /> */}
            <AutoPlaySlider>
            {iconImages.map((img, idx) => (
                <div key={idx}>
                    <div className='w-full flex items-center justify-center p-2 h-[250px] max-md:h-[150px]'>
                        <img
                        key={idx}
                        src={img.src}
                        alt={img.alt}
                        width={img.width}
                        height={img.height}
                        className="object-contain"
                        />
                    </div>
                </div>
            ))}
            </AutoPlaySlider>

            {/*pricing table section */}
            <PricingTable />

             {/* ready translation button */}
             <div className='readyTranslationBtn hover:scale-[1.02] transition-all duration-300' onClick={() => transitionTo(marketingLink)}>
                Experience faster, USCIS-ready translations
            </div>

            {/* Review section */}
            <Suspense fallback={<div>loading...</div>}>
                <div className='max-w-[1440px] w-full px-2'>
                    <CustomerReviews />
                </div>
            </Suspense>

           
            {/* <div
                className='border-b border-[#000] max-w-[1301px] sm:w-full w-[50%] mt-[94px]'
            /> */}

            {/* faq section */}
            <div className='faqSection max-auto' id="faqs">
                <p>
                    Clear answers to the most important questions from legal professionals
                </p>
                <div className="flex flex-col gap-4 mt-8">

                {faqQuestions.map((q, i) => (
                    // <AccordinItem key={i} question={q} answer={faqAnswers[i]} />
                    <QuestionAns
                    key={i}
                    question={q}
                    answer={faqAnswers[i]}
                    isOpen={activeIndex === i}
                    onToggle={() => handleToggle(i)}
                    html={true}
                    />
                ))}
                </div>
            </div>


            {/* text -- below now button */}
            <p className='textBelowStartNowBtn' id="start-now">Simplify your workflow and make the smartest decision for your firm. Leave behind manual management and confusion.</p>


            {/* start now button */}
            <div className='startNowBtn hover:scale-[1.02] transition-all duration-300' onClick={() => transitionTo(marketingLink)}>Start now for $24.95/page</div>

            {/* social icons */}
            <div className='socialIcons'>
                <SharedImage
                    src={require("../../assets/facebookIcon.png")}
                    alt="facebook icon"
                    width={125}
                    height={125}
                    className="object-contain"
                    rounded={true}
                    onClick={() => window.open("https://www.facebook.com/profile.php?id=100064195473455", "_blank")}
                    hover={true}
                />
                <SharedImage
                    src={require('../../assets/instagramIcon.png')}
                    alt="Instagram icon"
                    width={125}
                    height={125}
                    className="object-contain"
                    rounded={true}
                    onClick={() => window.open("https://www.instagram.com/e_verbary/", "_blank")}
                    hover={true}
                />
                <SharedImage
                    src={require('../../assets/linkedIn.png')}
                    alt="LinkedIn icon"
                    width={125}
                    height={125}
                    className="object-contain"
                    rounded={true}
                    onClick={() => window.open("https://www.linkedin.com/company/everbary/", "_blank")}
                    hover={true}
                />
            </div>
            

            {/* footer section */}
            {/* <div className='footerArea'>
                <SharedImage
                    src={require("../../assets/eVerbary Logo_Text_Inverted 1.png")}
                    alt="footer logo"
                    width={253}
                    height={53}
                    className="object-contain"
                />
            </div> */}

            <div className=' w-full pb-10 mt-10 bg-[#12ABBF]'>
                <Footer windowSize={windowSize} light={true} menuItems1={menuItems1} menuItems2={menuItems2} defaultPath="/partner" />
            </div>  
        </div>
    )
}

export default MarketingLandingPage;